import { sortRuleRoomsCount } from '../../../constants';
export function sortRoomsCount(rawValues) {
  return rawValues.sort(function (a, b) {
    return sortRuleRoomsCount.indexOf(a.value) - sortRuleRoomsCount.indexOf(b.value);
  });
}